module.exports = __webpack_public_path__ + "media/application/images/company/founders-bw/Michael-Robinson-acef944cc260d7cd6811c43f27cb9ddf.jpg";